import { ErrorApi } from '../../api/problema';
import { faltanDosPasos } from '../../logica/acceso';

/** Todas las páginas de una lista paginada por cursor (G121), una tras otra. Hasta 20 páginas, por si acaso. */
export async function todasLasPaginas<T>(pedir: (cursor: string | undefined) => Promise<{ data: T[]; next_cursor: string | null }>): Promise<T[]> {
    const todo: T[] = [];
    let cursor: string | undefined;
    for (let i = 0; i < 20; i++) {
        const pagina = await pedir(cursor);
        todo.push(...pagina.data);
        if (pagina.next_cursor === null || pagina.next_cursor === '') {
            break;
        }
        cursor = pagina.next_cursor;
    }
    return todo;
}

/** Sesión caducada (`401`) o faltan los dos pasos: los trata el marco. Devuelve true si ya está tratado. */
export function errorDelMarco(error: unknown, p: { onSesionCaducada: () => void; onFaltanDosPasos: () => void }): boolean {
    if (error instanceof ErrorApi && error.estado === 401) {
        p.onSesionCaducada();
        return true;
    }
    if (faltanDosPasos(error)) {
        p.onFaltanDosPasos();
        return true;
    }
    return false;
}
